const form = {
  formId: "form-cupom",
  formField: {
    codigoPromocional: {
      name: "codigoPromocional",
      label: "Código Promocional",
      type: "text",
      errorMsg: "Código Promocional é obrigatório",
    },
    dataInicio: {
      name: "dataInicio",
      label: "Data Início",
      type: "Date",
      errorMsg: "Data inicio é obrigatório",
    },
    validade: {
      name: "validade",
      label: "Validade",
      type: "Date",
      errorMsg: "Data validade é obrigatório",
    },
    qtdCupom: {
      name: "qtdCupom",
      label: "Qtd de Cupom",
      type: "text",
      errorMsg: "Quantidade de Cupom é obrigatório",
    },
    disponivel: {
      name: "disponivel",
      label: "Qtd Disponível",
      type: "text",
      errorMsg: "Qtd Disponível é campo obrigatório",
    },
    tipoPorcentagem: {
      name: "tipoPorcentagem",
      label: "Tipo Porcentagem",
      type: "text",
      errorMsg: "Tipo Porcentagem é campo obrigatório",
    },
    valorCupom: {
      name: "valorCupom",
      label: "Valor",
      type: "text",
      errorMsg: "Valor é campo obrigatório",
    },
    eventoId: {
      name: "evento",
      label: "Evento",
      type: "text",
      errorMsg: "Evento é campo obrigatório",
    },
    colorField: {
      name: "color",
      label: "Cor do Cupom",
      type: "text",
      errorMsg: "Cor é campo obrigatório",
    },
  },
};

export default form;
